import { memo } from 'react';
import styled from 'styled-components';
import { spacing, typography } from '@izettle/otto';

const SelectOptionTitleContainer = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "styles__SelectOptionTitleContainer",
  componentId: "zettle__sc-d5kjxy-0"
})(["display:flex;outline:none;background:none;border:none;min-height:fit-content;flex-direction:column;padding:", ";", ""], spacing.xSmall, typography.smallCapsSecondary));

export { SelectOptionTitleContainer };
//# sourceMappingURL=styles.js.map
